module.exports = __webpack_public_path__ + "img/40_38_033_020.28a59d00.jpg";